function VerEntrega({ actividad, entregaEstudiante }) {
    if ((!entregaEstudiante)||(!actividad)){
    return <p>No hay entrega disponible.</p>;
  }

  return (<>
        <div className="card p-3 my-1">
            <h5>{actividad.titulo}</h5>
            <p className="small">{actividad.desarrollo}</p>
            <div className="small"><i className="fa-regular fa-clock"></i><b> fecha de entrega:</b> {actividad.fecha_entrega}</div>
            <div className="alert alert-warning small" role="alert">
                <div><i className="fa-solid fa-circle-exclamation"></i> <b>Presentación</b>: {" "}
                {actividad.forma_presentacion ? actividad.forma_presentacion: 'no especificado'}
                </div>
            </div>
            <div className="small">El trabajo es de entrega <b>{actividad.tipo_trabajo}</b></div>
        </div>
        <hr />
        <div className="px-3">
            <div className="small"><i className="fa-regular fa-clock me-1"></i><strong> entregado el </strong> {entregaEstudiante.fecha_entrega}</div>
            <div className="alert alert-info small" role="alert"><strong>Comentario del estudiante:</strong> {entregaEstudiante.comentario}</div>
            <p>
                <i className="fa-solid fa-paperclip"></i>
                <strong>Archivo adjunto:</strong>{" "}
                <a href='#' target="_blank" rel="noopener noreferrer">
                    Ver archivo
                </a>
            </p>
        </div>
    </>
  );
}

export default VerEntrega;
